// extracted by mini-css-extract-plugin
export default {"navContainer":"MenuNavItem_navContainer__yu0yg","navItem":"MenuNavItem_navItem__S-KDL","active":"MenuNavItem_active__ZVpUT","menu":"MenuNavItem_menu__rF05j"};